import { ReactNode, useEffect } from 'react';

import { CircularProgressFullScreen } from '../../components/CircularProgressFullScreen/CircularProgressFullScreen';
import useLeadChannelStore from '../../store/leadChannelStore/useLeadChannelStore';
import useParameterStore from '../../store/parameterStore/useParameterStore';
import useTrackingPixelStore from '../../store/trackingPixelStore/useTrackingPixelStore';

const CmsGuard = ({ children }: { children: ReactNode }): ReactNode => {
  const { initLeadChannelFinished, initLeadChannel } = useLeadChannelStore();
  const { leadChannelCode } = useParameterStore();
  const { ensureTrackingPixelsLoaded } = useTrackingPixelStore();

  useEffect((): void => {
    initLeadChannel();

    // not awaited: warms the pixel list alongside the lead channel, never blocks the render
    ensureTrackingPixelsLoaded(leadChannelCode);
  }, [ensureTrackingPixelsLoaded, initLeadChannel]);

  if (!initLeadChannelFinished) {
    return <CircularProgressFullScreen />;
  }

  return children;
};

export default CmsGuard;
